import { useTranslation } from 'react-i18next'

import Text from '../../Text'

import * as styles from './ProfileAISummaryWidgetContent.module.css'

function ProfileAISummaryWidgetContent({
  className = styles.ProfileAISummaryWidgetContentText,
  files,
  ref,
  text,
  warningText,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <div className={styles.copyableContent} ref={ref}>
        <Text
          Element='div'
          className={styles.summaryText}
          dangerouslySetInnerHTML={{ __html: text }}
        />
        {files?.length > 0 ? (
          <div>
            <Text className={styles.title}>
              {t('Common.ProfileWidgetAISummaryFilesListTitleKey')}
            </Text>
            <ul className={styles.filesList}>
              {files.map((file, index) => (
                <li key={`${file.name}-${index}`}>
                  <Text>{`${file.name}: ${file.description}`}</Text>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
      <Text className={styles.warningText}>{warningText}</Text>
    </div>
  )
}

export default ProfileAISummaryWidgetContent
